module.exports = __webpack_public_path__ + "img/symbol-infinity-center.b9d05ab5.png";